import React, { useState, useEffect } from 'react';
import { getTheme, setTheme } from '../utils/localStorage';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const currentTheme = getTheme();
    setIsDark(currentTheme === 'dark');
  }, []);

  const toggleTheme = () => {
    const newTheme = isDark ? 'light' : 'dark';
    setTheme(newTheme);
    setIsDark(!isDark);
  };

  return (
    <div className="theme-toggle-container">
      <button className="theme-toggle" onClick={toggleTheme}>
        <div className="theme-icon">
          {isDark ? (
            <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
              <path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/>
              <path d="M12 7a5 5 0 100 10 5 5 0 000-10z"/>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
              <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>
            </svg>
          )}
        </div>
        <span className="theme-label">{isDark ? 'Light Mode' : 'Dark Mode'}</span>
        <div className={`theme-toggle-switch ${isDark ? 'active' : ''}`}>
          <div className="theme-toggle-slider"></div>
        </div>
      </button>
    </div>
  );
};

export default ThemeToggle;
